import { html } from 'lit-html';
import '../../global/animate.min.css';

/**
 * Allows users to select both a date and time.
 * It features a date input, a time input, and an AM/PM toggle button.
 */
export default {
  title: 'Components/DateTimePicker',
  tags: ['autodocs'],

  parameters: {
    actions: {
      handles: ['selectedDateEvent', 'selectedTimeEvent'], // Track the input and click events for the date, time, and toggle button
    },
  },
  argTypes: {
    required: {
      control: 'boolean',
      description: 'Dictates if the property is required.',
      table: {
        type: { summary: 'boolean' },
        defaultValue: { summary: false },
        category: 'Attributes',
      },
    },
    animation: {
      control: 'select',
      options: ["",
        "bounce", "flash", "pulse", "rubberBand", "shakeX", "shakeY", "headShake", "swing", "tada", "wobble", "jello", "heartBeat",
        "backInDown", "backInLeft", "backInRight", "backInUp",
        "backOutDown", "backOutLeft", "backOutRight", "backOutUp",
        "bounceIn", "bounceInDown", "bounceInLeft", "bounceInRight", "bounceInUp",
        "bounceOut", "bounceOutDown", "bounceOutLeft", "bounceOutRight", "bounceOutUp",
        "fadeIn", "fadeInDown", "fadeInDownBig", "fadeInLeft", "fadeInLeftBig", "fadeInRight", "fadeInRightBig", "fadeInUp", "fadeInUpBig", "fadeInTopLeft", "fadeInTopRight", "fadeInBottomLeft", "fadeInBottomRight",
        "fadeOut", "fadeOutDown", "fadeOutDownBig", "fadeOutLeft", "fadeOutLeftBig", "fadeOutRight", "fadeOutRightBig", "fadeOutUp", "fadeOutUpBig", "fadeOutTopLeft", "fadeOutTopRight", "fadeOutBottomRight", "fadeOutBottomLeft",
        "flip", "flipInX", "flipInY", "flipOutX", "flipOutY",
        "lightSpeedInRight", "lightSpeedInLeft", "lightSpeedOutRight", "lightSpeedOutLeft",
        "rotateIn", "rotateInDownLeft", "rotateInDownRight", "rotateInUpLeft", "rotateInUpRight",
        "rotateOut", "rotateOutDownLeft", "rotateOutDownRight", "rotateOutUpLeft", "rotateOutUpRight",
        "hinge", "jackInTheBox", "rollIn", "rollOut",
        "zoomIn", "zoomInDown", "zoomInLeft", "zoomInRight", "zoomInUp",
        "zoomOut", "zoomOutDown", "zoomOutLeft", "zoomOutRight", "zoomOutUp",
        "slideInDown", "slideInLeft", "slideInRight", "slideInUp",
        "slideOutDown", "slideOutLeft", "slideOutRight", "slideOutUp"
      ],
      description: 'Selects the animation effect to apply to the component.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: '' },
        category: 'Animations',
  
      },
    },
    animationDelay: {
      control: 'select',
      options: ["2s", "3s", "4s", "5s"],
      description: 'Sets the delay before the animation begins (in seconds).',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: '2s' },
        category: 'Animations',
  
      },
    },
    animationSpeed: {
      control: 'select',
      options: ["slow", "slower", "fast", "faster"],
      description: 'Controls how quickly the animation plays.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: '' },
        category: 'Animations',
  
      },
    },
    selectedDateEvent: {
      action: 'selectedDateEvent',
      description: 'Event emitted when date is selected.',
      table: {
        type: { summary: 'void' },
        defaultValue: { summary: ()=>{} },
        category: 'Events',
      },
    },
    selectedTimeEvent: {
      action: 'selectedTimeEvent',
      description: 'Event emitted when time is selected.',
      table: {
        type: { summary: 'void' },
        defaultValue: { summary: ()=>{} },
        category: 'Events',
      },
    },
    date: {
      control: 'text',
      description: 'Property designed to extract the component\'s selected date, e.g: comp.date',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: '' },
        category: 'Interaction',
      },
    },
    time: {
      control: 'text',
      description: 'Property designed to extract the component\'s selected time, e.g: comp.time',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: '' },
        category: 'Interaction',
      },
    },
    validate: {
      control: 'validate',
      description: 'Method to validate the component\'s value, e.g: comp.validate()',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: '' },
        category: 'Interaction',
      },
    },
  },
};

const Template = (args) => html`
  <gov-date-time-picker
  @selectedTimeEvent="${args.selectedTimeEvent}"
  @selectedDateEvent="${args.selectedDateEvent}"
      ?required="${args.required}"
  animation-delay="${args.animationDelay}"
  animation="${args.animation}"
  animation-speed="${args.animationSpeed}"
  ></gov-date-time-picker>
`;

export const DateTimePicker = Template.bind({});
DateTimePicker.args = {
  required:false,
  animation: '',
  animationDelay:'',
  animationSpeed: '',
};
